import { Type } from "@angular/core";
import { PointType, Transport } from "../pages/custom-route/interfaces/custom-route.interface";
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { PreviousPoint, SuggestedPoint } from "../pages/custom-route/shared/planner/components/route-timeline/components/daily-route-list/components/suggested-point-list/interfaces";

// DIALOG INTERFACES
export interface StandardDialogData {
  iconName?: string;
  title?: string;
  content?: ContentType;
  primaryActionButtonText?: string;
  secondaryActionButtonText?: string;
  handleClickPrimaryButton?: () => void;
  handleClickSecondaryButton?: () => void;
}

export type ContentType = string;
export interface DialogConfig<T, D = unknown> {
  component: Type<T>;
  data?: D;
  panelClass?: string | string[];
  backdropClass?: string | string[];
  enterAnimationDuration?: string;
  exitAnimationDuration?: string;
}

export interface MatDialogDetailsData {
  id: number;
  type: string;
  isValid?: boolean;
  fromPointPlannerCustomRouteDesktop?: boolean;
  fromMatDialog?: boolean;
  suggestedPoint?: SuggestedPoint;
  orderIndex?: number;
  dayToShowIndex?: number;
  slotStartDate?: string;
  previousPoint?: PreviousPoint;
  fromLocation?: any
}

export interface MatDialogTransportListData {
  transportList: Transport[];
  pointTitle: string;
  previousPointTitle: string;
  transportId?: number;
}

// BOTTOM SHEET INTERFACES
export interface BottomSheetData {
  id?: number;
  type?: PointType;
  isValid?: boolean;
  fromPointPlannerCustomRouteMobile?: boolean;
  fromPointPlannerCustomRouteDesktop?: boolean;
  suggestedPoint?: SuggestedPoint;
  orderIndex?: number;
  dayToShowIndex?: number;
  slotStartDate?: string;
  previousPoint?: PreviousPoint;
  transportList?: Transport[];
  pointTitle?: string;
  previousPointTitle?: string;
  isModal?: boolean
  defaultImg?: string
  categoryNameSlug?: string;
  fromLocation?: any
}

export interface MatBottomSheetAddNewPointData {
  title: string;
  dayToShowIndex: number;
  orderIndex: number;
  slotStartDate: string;
  previousPoint: PreviousPoint;
  fromChatBot?: boolean;
}

export interface BottomSheetConfig<T, D = unknown> {
  component: Type<T>;
  data?: D;
  panelClass?: string;
}

export enum BottomSheetLevel {
  CLOSED = 0,
  MINIMIZED = 1,
  MEDIUM = 2,
  EXPANDED = 3,
};

// SNACKBAR INTERFACES
export interface MatSnackbarData {
  message: string;
  iconName?: string;
}
export interface MatSnackbarConfig<T> {
  component: Type<T>;
  data?: MatSnackbarData;
  panelClass?: string;
  duration?: number; // Duration in milliseconds
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition
}
  